import { configureStore, combineReducers } from "@reduxjs/toolkit";

import authReducer from "./auth";

export const store = configureStore({
  reducer: combineReducers({
    auth: authReducer,
  }),
});
